module.exports = __webpack_public_path__ + "static/media/sap_io_logo_thumbnail.0357cc93.png";